      
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Grid } from '@mui/material';

class NotAuthorized extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="error-container">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                           <div className="error-content">
                                    <h3 className="text-uppercase">You do not have the Authorization to access this page</h3>
                                    <div className="error-content__button">
                                        <Link to="/" className="btn btn-primary waves-effect waves-light" >Back to Dashboard</Link>
                                    </div>
                                </div>
                        </Grid>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
}

export default NotAuthorized;